GatorSurvey.app.service('recaptchaService', ['$http', RecaptchaService]);

function RecaptchaService($http) {
    var ctrl = this;
    ctrl.PublicKey = "";
    ctrl.passed = false;
    ctrl.GetPublicKey = function () {
        return $http.get("api/recaptcha/get/publickey").then(function (response) {
            ctrl.PublicKey = response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    ctrl.VerifyRecaptcha = function (recaptchaResponse) {
        return $http.post("api/recaptcha/post/verify", recaptchaResponse).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    ctrl.create = function (elementName, data) {
        return grecaptcha.render(elementName, data);
    };

    ctrl.getResponse = function (widgetId) {
        return grecaptcha.getResponse(widgetId);
    };

    ctrl.reset = function (widgetId) {
        return grecaptcha.reset(widgetId);
    };

    ctrl.GetPublicKey();
}